export const formatCurrency = (amount, currency = 'KZT') => {
  return `${new Intl.NumberFormat('ru', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount || 0)} ${currency}`;
};

export const formatAmount = (amountInMinor) => {
  if (amountInMinor == null) return '-';
  const amount = amountInMinor / 100;
  return amount
    .toLocaleString('ru-RU', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })
    .replace(',', '.');
};

export const formatAmountV2 = (amountInMinor) => {
  if (amountInMinor == null) return '-';
  return amountInMinor
    .toLocaleString('ru-RU', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    })
    .replace(',', '.');
};

export const newFormatCurrency = (amount, currency = 'KZT') => {
  let numAmount = amount;
  if (typeof amount === 'string') {
    numAmount = parseFloat(amount.replace(',', '.'));
  }
  return `${new Intl.NumberFormat('ru', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(numAmount || 0).replace(',', '.')} ${currency}`;
};
